import axiosInstance from "@/api/axios";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    needs: [],
    adminNeeds: [],
    apiKey: "AIzaSyA_VN1fi0z37UyMvngr-vMVPUQpic_Tl08",
    timerInfo: null,
  },
  getters: {
    getAllNeeds(state) {
      return state.needs;
    },
    getAllAdminNeeds(state) {
      return state.adminNeeds;
    },
    getTimerInfo(state) {
      return state.timerInfo;
    }
  },
  mutations: {
    setNeeds(state, data) {
      state.needs = data;
    },
    setAdminNeeds(state, data) {
      state.adminNeeds = data;
    },
    addNeed(state, data) {
      const item = state.needs.find(item => item._id === data._id);
      if (item) {
        Object.assign(item, data);
      } else {
        state.needs.unshift(data);
      }
    },
    editNeed(state, data) {
      const item = state.needs.find(item => item._id === data._id);
      if (item) {
        Object.assign(item, data);
      } else {
        state.needs.push(data);
      }
    },
    deleteNeed(state, data) {
      state.needs = state.needs.filter(q => q._id !== data._id);
    },
    setTimerInfo(state, data) {
      state.timerInfo = data;
    }
  },
  actions: {
    fetchAllNeeds({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/all", params)
          .then(res => {
            if (res.data.success == true) {
              commit("setNeeds", res.data.res);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAllAdminNeeds({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        commit("setAdminNeeds", []);
        axiosInstance(rootState.auth.token)
          .post("need/adminNeedall", params)
          .then(res => {
            console.log(res, "adminNeedall");

            if (res.data.success == true) {
              // Store the entire response data including totalAgencies
              commit("setAdminNeeds", res.data);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAgencyNeeds({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/agency", { _id: params })
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchVolunteerNeeds({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/volunteer", { _id: params })
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchDateNeeds({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/date", { date: params })
          .then(res => {
            console.log(res, "fetchDateNeeds");
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchMonthNeeds({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/month", { month: params })
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getNeedDetails({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/get", params)
          .then(res => {
            if (res.data.success == true) {
              commit("addNeed", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUnAuthNeedDetails(_, params) {
      return new Promise((resolve, reject) => {
        const _id = params._id; // Ensure params contains _id
        const url = `${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-unauthneed`;
        axios
          .post(url, { _id }) // Pass params as the request body
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addNeed({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/add", params)
          .then(res => {
            if (res.data.success == true) {
              commit("addNeed", res.data.res);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    editNeed({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/update", params, { Authorization: rootState.auth.token })
          .then(res => {
            if (res.data.success == true) {
              commit("editNeed", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteNeed({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/delete", params)
          .then(res => {
            if (res.data.success == true) {
              commit("deleteNeed", res.data.res);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addPhoto({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/add-photo", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getLocation({ state }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${params}&key=${state.apiKey}`
          )
          .then(res => {
            if (res.data.results.length) {
              resolve(res.data.results[0].geometry.location);
            } else {
              reject("No locations");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getLocationWithAddress({ state }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${params}&key=${state.apiKey}`
          )
          .then(res => {
            if (res.data.results.length) {
              resolve(res.data.results[0]);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAllShifts({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("shift/all", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAllUnAuthShifts(_, params) {
      return new Promise((resolve, reject) => {
        const _id = params.need_id; // Ensure params contains _id
        const url = `${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-unauthshift`;
        axios
          .post(url, { _id }) // Pass params as the request body
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addShift({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("shift/add", params)
          .then(res => {
            console.log(res, "addShift");
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    editShift({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("shift/update", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteShift({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("shift/delete", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    respondShift({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("response/add", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onUpdateResponseNote({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("response/note", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    cancelResponse({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("response/cancel", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //download excel
    downloadExcel({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/getAgencyNeedsSummary", params, {
            responseType: "blob"
          })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //volunteer Download excel
    downloadVolunteerExcel({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/getVolunteerNeedsSummary", params, {
            responseType: "blob"
          })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getVolunteerList({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("need/getVolunteerList", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //filter Api
    getPdfData({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/volunteerSummaryPdf", params, {
            headers: {
              Authorization: rootState.auth.token
            },
            responseType: "blob"
          })
          .then(res => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(
                new Blob([res.data], { type: "application/pdf" })
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "volunteer_summary.pdf");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              resolve();
            } else {
              reject("Failed to download PDF");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
